<template>
  <div v-if="points" class="BookingRecapDiscount">
    <table class="BookingRecapDiscount-table">
      <ai-typo
        as="caption"
        variant="paragraph-03-bold"
        class="BookingRecapDiscount-title"
        color="white">
        {{ $t('booking.recap.prices.title') }}
      </ai-typo>
      <tbody>
        <tr colspan="2" class="BookingRecapDiscount-row">
          <ai-typo as="td" variant="paragraph-04-regular" color="white">
            {{ $t('booking.recap.prices.payWithPoints', { points }) }}
          </ai-typo>

          <td>
            <ai-amount
              :amount="amount * -1"
              :symbol="currencySymbol"
              color="white"
              main-typo="paragraph-02-bold"
              decimal-typo="paragraph-04-bold" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { useBookingStore } from '../../store';

const bookingStore = useBookingStore();
const points = computed(() => bookingStore.burntPoints);

const selectedVoucher = computed(() => {
  if (
    !bookingStore.currentBasket ||
    !Array.isArray(bookingStore.currentBasket.vouchers)
  )
    return;

  return bookingStore.currentBasket.vouchers.find(
    voucher => voucher.points === points.value,
  );
});
const voucherAmount = computed(() => selectedVoucher.value?.price?.amount ?? 0);
const voucherCurrency = computed(() => selectedVoucher.value?.price?.currency);

const voucherAmountInUserCurrency = useConvertToUserCurrency(
  voucherAmount,
  voucherCurrency,
);

const amount = computed(() => voucherAmountInUserCurrency.value.amount);
const currencySymbol = computed(
  () => voucherAmountInUserCurrency.value.currency?.code,
);
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';

.BookingRecapDiscount {
  width: 100%;
  background: constants.$linear-gradient-stratos;
  padding: constants.$padding-01;
}

.BookingRecapDiscount-table {
  width: 100%;
}

.BookingRecapDiscount-title {
  text-align: left;
}

.BookingRecapDiscount-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
